import 'fix-date'

import '@/utils/class-component-hooks'
import '@/styles/global.scss'

import Vue from 'vue'
import 'swiper/css/swiper.css'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import i18n from './lang'
import './moment'

import VuetifyToast from 'vuetify-toast-snackbar-ng'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import VueClipboard from 'vue-clipboard2'
import VSnackbars from 'v-snackbars'

import listenElectronIpcEvents, { isElectron } from './utils/electron'

import TournamentBracket from '@/plugins/TournamentBracket'
import Markdown from '@/plugins/Markdown'
import QuillDelta from '@/plugins/QuillDelta'
import LeagueIntegration from '@/utils/integration/lol'
import ImgFallback from '@/plugins/ImageFallback/directives'
import VueConfetti from 'vue-confetti'

import VueGtm from 'vue-gtm'
import Bracket from '@/plugins/TournamentBracket/Bracket.vue'

import VFormFileUploader from '@/modules/shared/components/VFormFileUploader'

Vue.directive('img-fallback', ImgFallback)
Vue.use(Markdown)
Vue.use(QuillDelta)
Vue.use(VueConfetti as any)
Vue.use(TournamentBracket)
Vue.component('v-snackbars', VSnackbars)
Vue.component('v-form-file-uploader', VFormFileUploader)

Vue.config.productionTip = false

// hide splash screen
const loadingContainer = document.getElementById('loading')
if (loadingContainer) {
  loadingContainer.className = 'hidden'
}

// add production class
const bodyContainer = document.getElementsByTagName('body')
if (bodyContainer[0] && process.env.NODE_ENV === 'production') {
  bodyContainer[0].classList.add('production')
}

// React Native webview interactions
Vue.prototype.$reactNativeWebView = (window as any).ReactNativeWebView
// Livechat.com Widget
Vue.prototype.$livechat = (window as any).LiveChatWidget

// WORKAROUND: ignore vuetify VCalendar issue (https://github.com/vuetifyjs/vuetify/issues/9999)
Vue.config.warnHandler = function(msg) {
  if (
    msg ===
    'The .native modifier for v-on is only valid on components but it was used on <div>.'
  ) {
    return
  }

  console.error(msg)
}

Vue.use(VuetifyToast, {
  x: 'center',
  y: 'bottom',
  timeout: 5000,
  dismissable: true,
  icon: 'info'
})

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

Vue.use(PerfectScrollbar)
Vue.use(VueClipboard)
Vue.use(VueFileAgent)
Vue.use(VueGtm, {
  id: 'GTM-TQFZX8W',
  enabled: !isElectron() && process.env.NODE_ENV === 'production',
  debug: process.env.NODE_ENV === 'development', // Whether or not display console logs debugs (optional)
  vueRouter: router
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

listenElectronIpcEvents()

// LOL integration
LeagueIntegration.init()
